var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _require = require('native-abort-controller'),
    AbortController = _require.AbortController;
/**
 * Takes an array of AbortSignals and returns a single signal.
 * If any signals are aborted, the returned signal will be aborted.
 * @param {Array<AbortSignal>} signals
 * @returns {AbortSignal}
 */


function anySignal(signals) {
  var controller = new AbortController();

  function onAbort() {
    controller.abort();

    var _iterator = _createForOfIteratorHelper(signals),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var signal = _step.value;
        if (!signal || !signal.removeEventListener) continue;
        signal.removeEventListener('abort', onAbort);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  var _iterator2 = _createForOfIteratorHelper(signals),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var signal = _step2.value;
      if (!signal || !signal.addEventListener) continue;

      if (signal.aborted) {
        onAbort();
        break;
      }

      signal.addEventListener('abort', onAbort);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return controller.signal;
}

module.exports = anySignal;
module.exports.anySignal = anySignal;